var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterView',{on:{"page":function($event){return _vm.$emit('page', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }